
const FloorplanLight: any = {
    version: 8,
    name: "i-bitz Style V.1",
    metadata: {
        "mapbox:autocomposite": false,
        "mapbox:type": "template",
        "maputnik:renderer": "mbgljs",
        "openmaptiles:version": "3.x",
        "openmaptiles:mapbox:owner": "openmaptiles",
        "openmaptiles:mapbox:source:url": "mapbox://openmaptiles.4qljc88t"
    },
    sources: {
    },
    sprite: "https://tile.i-bitz.co.th/styles/vallaris/sprite",
    glyphs: "https://tile.i-bitz.co.th/fonts/{fontstack}/{range}.pbf",
    layers: [
        {
            id: "background",
            type: "background",
            paint: {
                "background-color": "#ffffff"
            }
        }
    ],
    id: "VallarisMapStyle-Night"
};

export default FloorplanLight